import { render, staticRenderFns } from "./stats.sales-reporting.vue?vue&type=template&id=1600285c&scoped=true&"
import script from "./stats.sales-reporting.vue?vue&type=script&lang=js&"
export * from "./stats.sales-reporting.vue?vue&type=script&lang=js&"
import style0 from "./stats.sales-reporting.vue?vue&type=style&index=0&id=1600285c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600285c",
  null
  
)

export default component.exports